export default __webpack_public_path__ + "static/media/bateonIcon.6cc5e85c.svg";